import React from 'react';
import styled from 'styled-components';
import { panel } from './panelTheme';

// IL CAPITOLO — «AMBIENCE», «GROUND», «SCENE», «SHADING», «FILTERS».
//
// Non è un altro accordion: non si apre e non si chiude, e non ha una scatola. È l'indice di una
// colonna lunga — una parola in alto che dice di che cosa parlano le card sotto — e serve perché
// otto card di fila senza capitoli sono un elenco senza indice: si scorre e non si sa più dove si
// è.
//
// Sta qui e non nelle schermate perché ogni pannello della scena ne ha due o tre, e scritto in
// ogni editor sarebbe la stessa riga sei volte — con sei margini che, prima o poi, divergono.

// Il capitolo del prototipo (`.section.lead`): 10px, medio, il tono più quieto del testo.
const Eyebrow = styled.h4`
    margin: 0 0 6px;
    padding: 0 2px;
    color: var(--editor-chapter, ${panel.inkMuted});
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.08em;
    text-transform: uppercase;
`;

const Chapter = styled.section`
    & + & {
        margin-top: 14px;
    }
`;

export type PropertiesPanelSectionProps = {
    title: React.ReactNode;
    children: React.ReactNode;
};

export const PropertiesPanelSection: React.FC<PropertiesPanelSectionProps> = ({ title, children }) => (
    <Chapter>
        <Eyebrow>{title}</Eyebrow>
        {children}
    </Chapter>
);
